import { createContext } from "react";
export const MetaMaskContext = createContext({
    isConnected: false, 
    authenticate: () => {},
    contractAddress: '', 
    abi: null, 
    ethContract: null,
    contract: () => {},
    ethAddress: '',
    address: () => {},
    ensAddress: null,
    ens: () => {},
    network: {}
});